/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { Container, Grid } from '@material-ui/core';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import FooterBanner from './FooterBanner';

const styles = (theme) => {
    const { breakpoints: { maxWidth, minWidth }, typography: { cms = [] } } = theme;

    return {
        root: {
            '&.paid-search-page-wrapper': {
                '& .paid-search-wrapper': {
                    paddingBottom: '20px',
                    '& .paid-search-row': {
                        paddingTop: '50px',
                    },
                    maxWidth: '1270px',
                    [theme.breakpoints.down(maxWidth?.small_screen_up)]: {
                        maxWidth: '540px',
                    },
                    [theme.breakpoints.down(maxWidth?.big_screen_down)]: {
                        maxWidth: '960px',
                    },
                    [theme.breakpoints.down(maxWidth?.medium_screen_down)]: {
                        paddingBottom: '5px',
                        maxWidth: '720px',
                        '& .paid-search-row': {
                            paddingTop: '35px',
                            margin: '0px auto',
                        },
                    },
                    '& .content-wrapper': {
                        width: '90%',
                        position: 'absolute',
                        top: '46%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        margin: '0',
                        '& h2': {
                            fontSize: '2.2rem',
                            fontWeight: 600,
                            lineHeight: '36px',
                            color: '#fff',
                            paddingBottom: '22px',
                            [theme.breakpoints.between(minWidth?.small_medium_up, maxWidth?.medium_screen_down)]: {
                                paddingBottom: '15px',
                                paddingLeft: '8px',
                                paddingRight: '8px',
                            },
                            [theme.breakpoints.between(minWidth?.xs_large_screen_up, maxWidth?.small_screen_down)]: {
                                lineHeight: '30px',
                                paddingBottom: '10px',
                            },
                            [theme.breakpoints.between(minWidth?.xs_screen, maxWidth?.xs_large_screen)]: {
                                lineHeight: '24px',
                                fontSize: '1.375rem',
                                margin: 0,
                                paddingLeft: '7px',
                                paddingRight: '7px',
                            },
                            [theme.breakpoints.between(minWidth?.xxs_screen, maxWidth?.xxs_screen_up)]: {
                                lineHeight: '2opx !important',
                                paddingLeft: '10px',
                                paddingRight: '10px',
                            },
                        },
                        '& .paid-search-btn': {
                            border: '2px solid #fff',
                            padding: '8px 35px',
                            color: '#fff',
                            lineHeight: '46px',
                            fontWeight: 600,
                            textDecoration: 'none',
                            '&:hover': {
                                textDecoration: 'none',
                            },
                            [theme.breakpoints.down(maxWidth?.medium_screen_down)]: {
                                padding: '5px 25px',
                            },
                            [theme.breakpoints.down(maxWidth?.small_medium_down)]: {
                                padding: '4px 20px',
                            },
                            [theme.breakpoints.down(maxWidth?.small_screen_up)]: {
                                padding: '4px 15px',
                                lineHeight: '24px',
                                fontSize: '.75rem',
                            },
                        },
                    },
                    '& .banner-wrapper': {
                        paddingBottom: '30px',
                        position: 'relative',
                        paddingLeft: '15px',
                        paddingRight: '15px',
                        textAlign: 'center',
                        '& img': {
                            maxWidth: '100%',
                        },
                        [theme.breakpoints.down(maxWidth?.xs_large_screen)]: {
                            paddingBottom: '20px',
                            '&:nth-child( odd )': {
                                paddingRight: '10px',
                            },
                            '&:nth-child( even )': {
                                paddingLeft: '10px',
                            },
                        },
                    },
                },
                '& .above-footer-banner': {
                    width: '100vw !important',
                    position: 'relative',
                    marginLeft: '-50vw',
                    left: '49.3%',
                    '& img': {
                        maxWidth: '100%',
                    },
                    [theme.breakpoints.down(maxWidth?.small_screen_up)]: {
                        '& .d-md-block': {
                            display: 'none',
                        },
                        '& .d-md-none': {
                            display: 'block',
                        },
                    },
                    [theme.breakpoints.up(maxWidth?.small_screen_up)]: {
                        '& .d-md-none': {
                            display: 'none',
                        },
                        '& .d-md-block': {
                            display: 'block',
                            verticalAlign: 'middle',
                        },
                    },
                },
            },
        },
        topBannerWrapper: {
            '&.paid-search-title': {
                height: '30px',
                paddingLeft: '15px',
                paddingRight: '15px',
                '& .inner-title': {
                    width: '100%',
                    textAlign: 'center',
                    borderTop: '1px solid #000',
                    lineHeight: '0.1em',
                    margin: '0px',
                },
                '& .inner-title span': {
                    background: '#fff',
                    bottom: '30px',
                    fontSize: '1rem',
                    fontWeight: 400,
                    lineHeight: '18px',
                    padding: '5px 35px',
                    fontFamily: cms[5]?.font_name,
                    font: `normal normal 2.3rem/60px ${cms[5]?.font_name} !important`,
                    [theme.breakpoints.down(maxWidth?.small_screen_up)]: {
                        font: `normal normal 2em/60px ${cms[5]?.font_name} !important`,
                        padding: '5px 10px',
                    },
                    [theme.breakpoints.down(maxWidth?.xs_screen)]: {
                        font: `normal normal 1.5rem/60px ${cms[5]?.font_name} !important`,
                        padding: '5px 10px',
                    },
                    position: 'relative',
                },
                '& .search-items-wrapper': {
                    marginBottom: '20px',
                    '& p': {
                        position: 'absolute',
                        left: 0,
                    },
                },
                '& .search-title': {
                    font: 'normal normal bold 18px/22px Hind',
                    fontSize: '1rem',
                    lineHeight: '18px',
                },
                [theme.breakpoints.down(maxWidth?.medium_screen_down)]: {
                    height: '0px',
                },
            },
        },
        topBannerContainer: {
            '&.top-banner-container': {
                marginTop: '10px',
                [theme.breakpoints.between(minWidth?.medium_screen_down, maxWidth?.medium_screen_down)]: {
                    marginTop: '15px',
                },
                [theme.breakpoints.between(minWidth?.small_screen_down, maxWidth?.medium_screen_down)]: {
                    padding: '20px 0 20px 0',
                },
                [theme.breakpoints.down(maxWidth?.small_screen_up)]: {
                    paddingBottom: '10px',
                },
                [theme.breakpoints.down(maxWidth?.xs_large_screen)]: {
                    flexBasis: '72px',
                    flex: 1,
                    padding: '0 15px',
                },
                display: 'flex !important',
                '& .banners-wrapper': {
                    [theme.breakpoints.up(minWidth?.medium_screen_up)]: {
                        flex: 1,
                    },
                    [theme.breakpoints.down(maxWidth?.small_medium_down)]: {
                        margin: '10px',
                        textAlign: 'center',
                    },
                    '& .banner-inner-wrapper': {
                        display: 'block',
                        margin: '0 auto',
                        '& .img-wrapper': {
                            padding: '0px 0px 10px 0px',
                            [theme.breakpoints.down(maxWidth?.small_screen_up)]: {
                                padding: '0px',
                            },
                            '& img': {
                                maxWidth: '48px',
                                minHeight: '48px',
                                maxHeight: '48px',
                                margin: '0px auto',
                            },
                            '& img:nth-child(1)': {
                                display: 'none',
                            },
                            '& img:nth-child(2)': {
                                display: 'block',
                            },
                        },
                        '& .description-wrapper': {
                            textAlign: 'center',
                            '& p': {
                                [theme.breakpoints.up(minWidth?.medium_screen_up)]: {
                                    lineHeight: '22px',
                                    fontSize: '1.125rem',
                                },
                                overflow: 'hidden',
                                fontSize: '0.875rem',
                                padding: 0,
                            },
                            '& .description': {
                                display: 'none',
                            },
                        },
                        [theme.breakpoints.up(minWidth?.medium_screen_up)]: {
                            '& .description-wrapper': {
                                textAlign: 'left',
                                '& .description': {
                                    display: 'block !important',
                                    fontSize: '0.875rem',
                                    lineHeight: 'inherit',
                                    marginTop: 0,
                                    marginBottom: '1.4rem',
                                    fontFamily: `${cms[0]?.font_name},sans-serif`,
                                },
                            },
                            display: 'flex',
                            '& .img-wrapper': {
                                padding: '0 12px 0 10px',
                                '& img:nth-child(1)': {
                                    display: 'block',
                                },
                                '& img:nth-child(2)': {
                                    display: 'none',
                                },
                                '& img': {
                                    marginTop: '-2px !important',
                                    maxWidth: '100px !important',
                                },
                            },
                        },
                        '& .description-information': {
                            textAlign: 'left',
                        },
                        '& img': {
                            height: 'auto',
                            [theme.breakpoints.down(maxWidth?.small_screen_up)]: {
                                paddingBottom: '8px',
                            },
                            [theme.breakpoints.up(minWidth?.big_screen_down)]: {
                                float: 'left',
                            },
                        },
                        '& .block-title': {
                            [theme.breakpoints.up(minWidth?.medium_screen_up)]: {
                                '&.desktop-title': {
                                    display: 'block !important',
                                    fontFamily: `'${cms[0]?.font_name}',sans-serif`,
                                },
                                '&.mobile-title': {
                                    display: 'none !important',
                                },
                                fontWeight: 600,
                                lineHeight: '22px',
                                paddingBottom: '15px',
                                fontSize: '1.125rem !important',
                            },
                            '&.desktop-title': {
                                display: 'none',
                            },
                            '&.mobile-title': {
                                display: 'block',
                            },
                            margin: 0,
                            lineHeight: '16px',
                            overflow: 'hidden',
                            '-webkit-box-orient': 'vertical',
                            '-webkit-line-clamp': 2,
                            fontSize: '0.875rem',
                        },
                    },
                },
            },
        },
    };
};

const SeoPlantsDelivery = ({ classes, data }) => {
    const {
        hero: { title = '', copy = '' }, related_articles: { articles = [] }, hero: { hero_image_desktop = {}, hero_image_mobile = {} }, article_body = '',
    } = data;

    const renderLinks = articles.map(({ image, link }) => {
        const url = image?.url || '';
        const linkTitle = link?.title || 'No Title';
        const href = link?.href || '#';
        return (
            <Grid xs={6} sm={6} md={5} className="banner-wrapper">
                <div className="banner-inner-wrapper">
                    <img src={url} alt={title} />
                    <div className="content-wrapper">
                        <h2 className="title">{linkTitle}</h2>
                        <Link to={href} className="paid-search-btn">SHOP NOW</Link>
                    </div>
                </div>
            </Grid>
        );
    });

    return (
        <div className={`${classes.root} paid-search-page-wrapper`}>
            <Container className="paid-search-wrapper">
                <Grid container className="paid-search-row" direction="row" justifyContent="center" wrap>
                    <>
                        <Grid item md={10} xs={10} className={`${classes.topBannerWrapper} paid-search-title`}>
                            <h6 className="inner-title"><span>{title}</span></h6>
                        </Grid>
                        <Grid xs={12} md={10} className={`${classes.topBannerContainer} top-banner-container`} justifyContent="center">
                            {ReactHtmlParser(copy)}
                        </Grid>
                    </>
                    <Grid xs={12} sm={10} md={12} container direction="row" justifyContent="center">
                        {renderLinks}
                    </Grid>
                </Grid>
            </Container>
            <FooterBanner data={article_body} />
            <section className="above-footer-banner">
                <img
                    alt="as seen in"
                    src={hero_image_desktop?.url}
                    className="d-none d-md-block"
                />
                <img
                    alt="as seen in"
                    src={hero_image_mobile?.url}
                    className="d-md-none"
                />
            </section>
        </div>
    );
};

SeoPlantsDelivery.propTypes = {
    classes: object.isRequired,
    data: object.isRequired,
};

export default withStyles(styles)(SeoPlantsDelivery);
